import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

interface Lecture {
    title: string;
}

interface AddChapterDTO {
    name: string;
    courseId: string;
    description:string;
    lectures: Lecture[];
}

interface ChapterResponse extends AddChapterDTO, ApiError {
    id: string;
    createdAt: string;
    updatedAt: string;
}
export const AddNewOfflineChapter = (data: AddChapterDTO): Promise<ChapterResponse> => {
    return axios.post("/chapter/createForOfflineCourse", data)
        .then(response => response.data as ChapterResponse);
};